<template>
    <div>
        <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-8 pb-8" v-if="isLoaded">
            <div>
                <div class="lg:border lg:border-a-brown-d7c7b8 lg:rounded-20 lg:overflow-hidden lg:pt-4">
                    <Header></Header>
                    <DeliveryStatus></DeliveryStatus>
                </div>
            </div>
            <div>
                <div class="lg:border lg:border-a-brown-d7c7b8 lg:rounded-20 lg:overflow-hidden">
                    <OrderDetail></OrderDetail>
                    <div class="hidden lg:flex">
                        <div class="w-52 m-auto pb-4">
                            <Contact @onClick="onClickContactCC()"></Contact>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed as vueComputed } from "vue";
//component
import Header from "./Header.vue"
import DeliveryStatus from "./DeliveryStatus.vue"
import OrderDetail from "./OrderDetail.vue"
import Contact from "./Contact.vue"

export default {
    name: "TrackingItem",
    components: {
        Header,
        DeliveryStatus,
        OrderDetail,
        Contact
    },
    props: {
        orderItem: Object
    },
    data: function () {
        return {
            orderDetail: [],
            isLoaded: false
        }
    },
    provide: function () {
        return {
            getTracking: vueComputed(() => this.orderItem),
            getOrderItems: vueComputed(() => this.orderDetail)
        }
    },
    created: function () {
        this.orderDetail = this.orderItem.items;
        this.isLoaded = true;
    },
    methods: {
        onClickContactCC: function(){
             this.tracking.event('shopping_bag','Click_contact1112','call1112','When user click confirm to calling 1112​');
            window.open("tel:1122", "_self")
        }
    }
}
</script>

<style>

</style>
